import TastypieCollection from './TastypieCollection';

export default class SelectableCollection extends TastypieCollection {
  initialize(options) {
    this.listenTo(this, 'addedToSelection', this.modelAddedToSelection);
    this.listenTo(this, 'addedToNewSelection', this.modelAddedToNewSelection);
    this.listenTo(this, 'removedFromSelection', this.modelRemovedFromSelection);
    super.initialize(options);
  }

  modelAddedToSelection(selectedModel) {

  }

  modelAddedToNewSelection(selectedModel) {
    this.each(function(model)  {
      if (model !== selectedModel) {
        model.deselect();
      }
    });
  }

  modelRemovedFromSelection() {

  }

  deselectAll() {
    this.each(function(model)  {
      model.deselect();
    });
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/models/SelectableCollection.js
 **/